import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { ForgotPasswordService } from 'src/app/page//forgot-password/service/forgot-password.service';
import { Router } from '@angular/router';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { CryptoService } from 'src/app/services/crypto/crypto.service';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';

@Component({
	selector: 'app-forgot-password',
	templateUrl: './forgot-password.component.html',
	styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent implements OnInit {
	labels: LabelsInterface = {
		lbl_an_errour_occour: 'An error occurred. Please try again',
	};

	constructor(
		private forgotPasswordService: ForgotPasswordService,
		private route: ActivatedRoute,
		private Router: Router,
		private Notification: NotificationService,
		private LabelsService: LabelsService,
		private CryptoService: CryptoService
	) {
		this.route.params.subscribe((parameters) => (this.token = parameters['token']));
	}

	isLoadingLabels = true;
	email = '';
	token: string;
	userLang: string;
	customerLogoUrl = 'assets/images/Atos.svg';

	isLoadingEmail = true;

	ngOnInit() {
		this.LabelsService.getLabels()
			.subscribe((labels) => {
				this.labels = labels;
				this.isLoadingLabels = false;
			})
			.add(() => {
				try {
					const pwResetToken = localStorage.getItem('pwResetToken');
					const decryptB64 = this.CryptoService.decryptB64(this.token);
					if (pwResetToken === decryptB64) {
						const decryptedEmail = this.CryptoService.decryptAES(decryptB64);
						this.email = decryptedEmail;
						this.isLoadingEmail = false;
					} else {
						throw new Error();
					}
				} catch {
					this.Notification.setNotificationMessage(this.labels.lbl_an_errour_occour);
					this.Router.navigate(['/login']);
				}
			});
	}
}
